// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OG3Y","left":"styles_left__26GPI","desktopActions":"styles_desktopActions__1b8mt","title":"styles_title__-KcPs"};